import { ArrowRight } from "lucide-react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GUIDES, articlePath } from "../data/guides";
import { BlogCTA } from "../components/BlogCTA";

const SITE_URL = "https://biedradar.nl";

export function Blog() {
  const { t } = useTranslation();
  const canonical = `${SITE_URL}/blog`;
  const description =
    "Artikelen en gidsen over de Nederlandse woningmarkt: overbieden, taxatie, WOZ, hypotheek en biedstrategie — met cijfers en concrete stappen.";

  return (
    <>
      <Helmet>
        <title>Blog - Biedradar</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonical} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Blog - Biedradar" />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonical} />
        <meta property="og:image" content={`${SITE_URL}/og-image.png`} />
        <meta property="og:site_name" content="Biedradar" />
      </Helmet>

      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8">
        <div className="mb-10">
          <h1 className="font-display text-4xl font-extrabold tracking-tight text-ink sm:text-5xl">
            {t("blog.indexTitle")}
          </h1>
          <p className="mt-3 max-w-2xl text-lg leading-relaxed text-ink-muted">
            {t("blog.indexSubtitle")}
          </p>
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:gap-6">
          {GUIDES.map((post) => (
            <Link
              key={post.slug}
              to={articlePath(post)}
              className="group flex flex-col rounded-xl border border-line bg-surface-2 p-6 shadow-soft transition-all hover:-translate-y-0.5 hover:border-brand/40 hover:shadow-pop sm:p-7"
            >
              <div className="mb-3 flex items-center gap-3">
                <span className="inline-flex items-center whitespace-nowrap rounded-md bg-brand/10 px-2.5 py-1 text-xs font-semibold uppercase tracking-wide text-brand-soft">
                  {post.category}
                </span>
                <span className="text-xs font-medium text-ink-faint">
                  {post.readingTime} {t("blog.minRead")}
                </span>
              </div>
              <h2 className="mb-2.5 text-xl font-bold leading-snug tracking-tight text-ink transition-colors group-hover:text-brand-soft sm:text-[22px]">
                {post.title}
              </h2>
              <p className="text-[15px] leading-relaxed text-ink-muted">
                {post.excerpt}
              </p>
              <div className="mt-4 flex items-center gap-1.5 text-sm font-semibold text-brand-soft">
                {t("blog.readMore")}
                <ArrowRight
                  size={15}
                  className="transition-transform group-hover:translate-x-0.5"
                />
              </div>
            </Link>
          ))}
        </div>

        <BlogCTA image="/neo-hypotheken-ander-huis-kopen.jpg" />
      </div>
    </>
  );
}
